import { required, TextInput, SimpleForm } from "react-admin";

const validateRequired = [required()];

export const CompanyForm = (props: any) => (
  <SimpleForm warnWhenUnsavedChanges {...props}>
    <TextInput source="name" validate={validateRequired} fullWidth />
    <TextInput source="cnpj" fullWidth />
  </SimpleForm>
);

export { CompanyList } from './List';
export { CompanyCreate } from './Create';
export { CompanyEdit } from './Edit';
export { CompanyIcon } from './Icon';
